<form #equipmentTypeForm="ngForm" class="col">
    <div class="row">
        <mat-form-field appearance="outline" class="fx-50">
            <mat-label>Name</mat-label>
            <input matInput 
                [(ngModel)]="equipmentType.Name" 
                [ngModelOptions]="{standalone: true}" 
                maxlength="50"
                placeholder="enter name">
        </mat-form-field>

        <app-autocomplete-dropdown
            [parentFormControl]="equipmentTypeForm.control"
            [options]="orderTypes"
            [label]="'Order type'"
            [displayProperty]="'Name'"
            [defaultValue]="orderTypeDefValue"            
            [placeholder]="'select order type'"
            [required]="true"
            (selectedChanged)='onOrderTypeChanged($event)'
            (clicked)="onLoadOrderTypes()"
            class="fx-50">
        </app-autocomplete-dropdown>
    </div>
    <div class="row">
        <mat-form-field appearance="outline" class="fx-50">
            <mat-label>Region</mat-label>
            <input matInput
                type="text"
                placeholder="select or type new region"
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="regionInputValue"
                [matAutocomplete]="regionAuto"
                (ngModelChange)="onRegionInputChange($event)"
                (focus)="onLoadRegions()"
                (blur)="onRegionBlur()">
            <button *ngIf="regionInputValue"
                matSuffix mat-icon-button
                matTooltip="Clear region"
                aria-label="Clear"
                type="button"
                (click)="clearRegion()">
                <mat-icon>close</mat-icon>
            </button>
            <mat-icon *ngIf="!regionInputValue" matSuffix class="pointer">keyboard_arrow_down</mat-icon>
            <mat-autocomplete #regionAuto="matAutocomplete"
                (optionSelected)="onRegionOptionSelected($event)">
                <mat-option *ngFor="let r of filteredRegions" [value]="r.Name">
                    {{ r.Name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</form>